module.exports = __webpack_public_path__ + "media/images/application/template/products/homepage_20ft_mob-0200b671cf4f35ac9f25a1e94ec5cd1b.png";